import { Button, Dialog, EButtonColor } from '@web_opxp/components';
import { renderStringToReact, useTranslation } from '@web_opxp/features';
import './ConfirmSkipAssessmentDialog.scss';

export interface IConfirmaSkipAssessmentDialogProps {
  show: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function ConfirmaSkipAssessmentDialog({
  show,
  onCancel,
  onConfirm,
}: Readonly<IConfirmaSkipAssessmentDialogProps>) {
  const { t } = useTranslation();
  const title = t('Dashboard.SkipAssessmentConfirmation.Title');
  const proceed = t('Dashboard.SkipAssessmentConfirmation.Proceed');
  const cancel = t('Dashboard.SkipAssessmentConfirmation.Cancel');
  const description = renderStringToReact(t('Dashboard.SkipAssessmentConfirmation.TextHtml'));
  return (
    <Dialog isOpen={show} onClose={onCancel}>
      <div className="skip-assessment-confirmation">
        <h3>{title}</h3>
        {description}
        <div className="skip-assessment-confirmation-actions">
          <Button color={EButtonColor.white} label={cancel} onClick={onCancel} />
          <Button color={EButtonColor.blue} label={proceed} onClick={onConfirm} />
        </div>
      </div>
    </Dialog>
  );
}
